<div class="badge-events-container">
  <!-- Unified Tool Header -->
  <div class="unified-tool-header">
    <div class="header-content">
      <div class="header-icon">
        <svg viewBox="0 0 24 24" class="tool-icon">
          <path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,17H7V15H17V17M17,13H7V11H17V13M17,9H7V7H17V9Z" />
        </svg>
      </div>
      <div class="header-text">
        <h1>Badge Editor</h1>
        <p>Select an event with registration forms to design badges for</p>
      </div>
    </div>
  </div>

  <!-- Tool Content -->
  <div class="tool-content">
    <!-- Event Selection Section -->
    <div class="event-selection-section">
      <!-- Search Section -->
      <div class="search-section">
        <div class="search-container">
          <svg viewBox="0 0 24 24" class="search-icon">
            <path
              d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
            />
          </svg>
          <input type="text" placeholder="Search events..." [value]="searchTerm" (input)="onSearchTermChangedEvent($event)" class="search-input" />
          <div class="search-actions" *ngIf="searchTerm?.trim()">
            <button class="search-btn" (click)="searchEvents()" title="Search">
              <svg viewBox="0 0 24 24">
                <path
                  d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
                />
              </svg>
            </button>
            <button class="clear-btn" (click)="clearSearch()" title="Clear search">
              <svg viewBox="0 0 24 24">
                <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Loading Section -->
      <div *ngIf="isLoading" class="loading-section">
        <div class="loading-spinner"></div>
        <p>Loading events...</p>
      </div>

      <!-- Error Section -->
      <div *ngIf="errorMessage && !isLoading" class="error-section">
        <div class="error-content">
          <svg viewBox="0 0 24 24" class="error-icon">
            <path
              d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"
            />
          </svg>
          <div class="error-text">
            <h3>{{ hasWorkspaceError ? 'Workspace Error' : 'Error Loading Events' }}</h3>
            <p>{{ errorMessage }}</p>
          </div>
        </div>
      </div>

      <!-- Events Grid -->
      <div *ngIf="!isLoading && !errorMessage && events.length > 0" class="events-grid">
        <ngx-admin-event-card *ngFor="let event of events" [event]="event" [isSelected]="selectedEventId === event.id" [context]="'badge-editor'" (cardClick)="selectEvent($event)">
        </ngx-admin-event-card>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && !errorMessage && events.length === 0" class="empty-state">
        <div class="empty-illustration">
          <svg viewBox="0 0 24 24" class="empty-icon">
            <path
              d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z"
            />
          </svg>
        </div>
        <h3>No Events Available</h3>
        <p>There are no events in your workspace yet.</p>
      </div>
    </div>
  </div>
</div>
